import { _ as t } from "../internals/export.js";
import { o as r } from "../internals/object-to-array.js";
var e = r.entries;
t({
  target: "Object",
  stat: !0
}, {
  entries: function entries(t) {
    return e(t);
  }
});